import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { setKey, session } from "../../store/actions";
import { connect } from "react-redux";
import categoryService from "../../services/category";
import { swalError } from "../../utils/swal";
import Buttons from "./Buttons";

function CustomFieldText({ session, setKey, selectedField, ...props }) {
	const { t } = useTranslation();
	const defaultObj = {
		labelEn: "",
		labelAr: "",
		placeholderEn: "",
		placeholderAr: "",
		max: 100,
		min: 1
	};
	const [currentObj, setCurrentObj] = useState(defaultObj);
	const [previewLanguage, setPreviewLanguage] = useState("en");

	useEffect(() => {
		if (selectedField) {
			setCurrentObj(JSON.parse(selectedField.config));
		}
	}, [selectedField]);

	const handleSave = async e => {
		e.preventDefault();
		props.saveField("number", currentObj);
	};

	return (
		<>
			<div className="row mt-30">
				<div className="col text-left">
					<h4>{t("configure")} ({t("field_type_number")})</h4>
				</div>
			</div>
			<div className="row mt-10">
				<div className="col-6">
					<h5>{t("configure")}</h5>
					{t("label_en")}{" "}
					<input
						type="text"
						className="form-control mb-2"
						placeholder={t("label_en")}
						value={currentObj?.labelEn}
						onChange={e =>
							setCurrentObj({
								...currentObj,
								labelEn: e.target.value
							})
						}
					/>
					{t("placeholder_en")}{" "}
					<input
						type="text"
						className="form-control mb-2"
						placeholder={t("placeholder_en")}
						value={currentObj?.placeholderEn}
						onChange={e =>
							setCurrentObj({
								...currentObj,
								placeholderEn: e.target.value
							})
						}
					/>
					{t("label_ar")}{" "}
					<input
						type="text"
						className="form-control mb-2"
						placeholder={t("label_ar")}
						value={currentObj?.labelAr}
						onChange={e =>
							setCurrentObj({
								...currentObj,
								labelAr: e.target.value
							})
						}
					/>
					{t("placeholder_ar")}{" "}
					<input
						type="text"
						className="form-control mb-2"
						placeholder={t("placeholder_ar")}
						value={currentObj?.placeholderAr}
						onChange={e =>
							setCurrentObj({
								...currentObj,
								placeholderAr: e.target.value
							})
						}
					/>
					{t("min_value")}{" "}
					<input
						type="number"
						className="form-control mb-2"
						placeholder={t("min_value")}
						value={currentObj?.min}
						onChange={e =>
							setCurrentObj({
								...currentObj,
								min: e.target.value
							})
						}
					/>
					{t("max_value")}{" "}
					<input
						type="number"
						className="form-control mb-2"
						placeholder={t("max_value")}
						value={currentObj?.max}
						onChange={e =>
							setCurrentObj({
								...currentObj,
								max: e.target.value
							})
						}
					/>
					<Buttons
						clearValues={() => setCurrentObj(defaultObj)}
						save={handleSave}
						delete={props.deleteField}
					/>
				</div>
				<div className="col-6">
					<h5>{t("output_preview")}</h5>
					<div
						className="btn-group btn-group-toggle btn-sm"
						data-toggle="buttons"
						style={{ marginLeft: 0, paddingLeft: 0 }}
					>
						<label className="btn btn-primary btn-sm active">
							<input
								type="radio"
								name="options"
								id="option-en"
								autoComplete="off"
								checked
								onClick={() => setPreviewLanguage("en")}
							/>{" "}
							{t("english_label")}
						</label>
						<label className="btn btn-primary btn-sm">
							<input
								type="radio"
								name="options"
								id="option-ar"
								autoComplete="off"
								onClick={() => setPreviewLanguage("ar")}
							/>{" "}
							{t("arabic_label")}
						</label>
					</div>{" "}
					<br />
					<div className="mt-20">
						{currentObj && previewLanguage === "en" && (
							<>
								<label>{currentObj.labelEn}</label>
								<input
									type="number"
									className="form-control"
									placeholder={currentObj.placeholderEn}
									min={currentObj.min}
									max={currentObj.max}
								/>
							</>
						)}
						{currentObj && previewLanguage === "ar" && (
							<>
								<label className="text-right w-100">
									{currentObj.labelAr}
								</label>
								<input
									dir="rtl"
									type="number"
									className="form-control"
									placeholder={currentObj.placeholderAr}
									min={currentObj.min}
									max={currentObj.max}
								/>
							</>
						)}
					</div>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = store => ({ session: store.session });
const mapDispatchToProps = dispatch => ({
	setKey: (key, value) => dispatch(setKey(key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomFieldText);
